var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM10.555 7.036A1 1 0 0 0 9 7.87v8.262a1 1 0 0 0 1.555.832l6.197-4.13a1 1 0 0 0 0-1.665l-6.197-4.132z","fill":"#55FF8A"}));
}

Play.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Play;

Play.default = Play;
